export enum RoleType {
  admin = 'admin',
  purchaser = 'purchaser',
  purchasemanager = 'purchasemanager',
  salesperson = 'salesperson',
  salesmanager = 'salesmanager',
  // estimator = 'estimator'
}

export const estimatePermissionRoles = (): string[] => {
  const roleList: string[] = [];
  Object.keys(RoleType).forEach((role) => {
    roleList.push(role)
  });
  return roleList
}
// 'qc',
export const editableRole: string[] = [ 'reconditioning_manager', 'estimator', 'admin' ]; // Role for form edit
export const mediaAdmin: string[] = ['media_admin', 'admin']; // Role for gallery and report page access